import React from 'react'
import { translateNode } from 'src/localization/translateNode'

export interface AddressResponse {
  address1: string
  address2?: string
  city: string
  country: string
  province: string
  postal: string
}

export class AddressModel {
  public address1: string
  public address2?: string
  public city: string
  public country: string
  public province: string
  public postal: string

  public constructor(data: AddressResponse) {
    this.address1 = data.address1
    this.address2 = data.address2
    this.city = data.city
    this.country = data.country
    this.province = data.province
    this.postal = data.postal
  }

  public get fullAddressLabel(): React.ReactElement {
    return this.address2
      ? translateNode(
          '${address1}, ${address2}, ${city}, ${province}, ${country}, ${postal}',
          {
            address1: this.address1,
            address2: this.address2,
            city: this.city,
            country: this.country,
            province: this.province,
            postal: this.postal,
          },
        )
      : translateNode(
          '${address1}, ${city}, ${province}, ${country}, ${postal}',
          {
            address1: this.address1,
            city: this.city,
            country: this.country,
            province: this.province,
            postal: this.postal,
          },
        )
  }
}
